export enum E_NICK_NAME_COLUMNS {
  PREFIX_COL_NUM = 0,
  SUFFIX_COL_NUM = 1
}
